import React from "react";
import "./M3D.css";
import M3 from "../../../Gallery/ServicesImages/M3/M3D.avif"
import { useNavigate } from "react-router-dom";

function Metal3D() {

  const navigate = useNavigate();
  return (
    <section className="metal3d-section">

      <div className="metal3d-container">

        {/* LEFT IMAGE */}
        <div className="metal3d-image">
          <img src={M3} alt="Metal 3D Printing Machine" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="metal3d-content">

          <h1>Metal 3D Printing</h1>
          <div className="underline"></div>

          <p>
            Metal 3D Printing, also known as metal additive manufacturing, 
            is revolutionizing the industry by enabling the creation of highly 
            precise and durable metal components. Using laser fusion technology, 
            complex geometries that are impossible with traditional machining 
            become achievable, improving efficiency and structural performance.
          </p>

          <p>
            This advanced process allows rapid production, reduced material waste, 
            and high customization flexibility. Whether for prototypes, functional 
            parts, or end-use components, Metal 3D printing ensures superior strength, 
            accuracy, and reliability across aerospace, automotive, medical, and 
            industrial applications.
          </p>

          <button className="metal3d-btn" onClick={() => navigate("/contact")}>Contact</button>

        </div>
      </div>

    </section>
  );
}

export default Metal3D;
